import { Ad } from "./Ad.model";

export class ContentCatalogFolder {
  id: number;
  name: string;
  children: ContentCatalogFolder[];
  ads: Ad[];
  sequence_order: number;
  organization_id: number | null;
  organization_name: string | null;

  constructor() {
    this.id = -1;
    this.name = "";
    this.children = [];
    this.ads = [];
    this.sequence_order = 0;
    this.organization_id = null;
    this.organization_name = null;
  }
}
